export default __webpack_public_path__ + "static/media/layer-manual-drive.87b1a5c7.svg";